import type { KVContent } from '@/models/interface/kv';
import { ApiFactory } from '@/utils/api';

export class KVService extends ApiFactory {
  constructor() {
    super('https://newapi.funday.asia/api/v1');
  }

  fetchAll(p?: { page: number; size: number }): Promise<{
    data: {
      content: KVContent;
      isSuccess: boolean;
      errorCode: any;
      errorMessage: any;
    };
  }> {
    return super.get(
      'KV',
      {
        page: 1,
        size: 1
      },
      {
        headers: {
          disableGlobalLoading: true
        }
      }
    );
  }
}
